import { render, staticRenderFns } from "./ListaRecepcionistasUnidade.vue?vue&type=template&id=12929e9c&scoped=true"
import script from "./ListaRecepcionistasUnidade.vue?vue&type=script&lang=js"
export * from "./ListaRecepcionistasUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaRecepcionistasUnidade.vue?vue&type=style&index=0&id=12929e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12929e9c",
  null
  
)

export default component.exports